import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GeneralButton from '../button_general';
import DietaryRestrictionDropdown from '../dropdowns/dropdown_dietary_restrictions';
import TypeDropdown from '../dropdowns/dropdown_item_types';
import CategoryDropdown from '../dropdowns/dropdown_item_category';

function ItemFilterComponent({ onFilterChange, selectedType, selectedCategory, selectedDietaryRestriction }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleFilterApply = (type, category, dietaryRestriction) => {
    const params = new URLSearchParams(location.search);

    if (type && type !== 'All') {
      params.set('type', type);
    } else {
      if (type === 'All') {
        type = '';
      }
      params.delete('type');
    }

    if (category && category !== 'All') {
      params.set('category', category);
    } else {
      if (category === 'All') {
        category = '';
      }
      params.delete('category');
    }

    if (dietaryRestriction && dietaryRestriction !== 'All') {
      params.set('dietary_restriction_type', dietaryRestriction);
    } else {
      if (dietaryRestriction === 'All') {
        dietaryRestriction = '';
      }
      params.delete('dietary_restriction_type');
    }

    navigate({ search: params.toString() });
    onFilterChange(type, category, dietaryRestriction);
  };

  const handleFilterClear = () => {
    navigate({ search: '' });
    onFilterChange('', '', '');
  };

  return (
    <div className="filter-component flex flex-wrap items-end space-x-4 ml-2 mb-2">
      <TypeDropdown 
        onSelect={(item) => handleFilterApply(item.name, selectedCategory, selectedDietaryRestriction)} 
        selectedType={selectedType} 
      />
      <CategoryDropdown 
        onSelect={(item) => handleFilterApply(selectedType, item.name, selectedDietaryRestriction)} 
        selectedCategory={selectedCategory} 
      />
      <DietaryRestrictionDropdown 
        onSelect={(selectedItems) => handleFilterApply(selectedType, selectedCategory, selectedItems.length > 0 ? selectedItems[0].name : '')}  
        selectedRestrictions={selectedDietaryRestriction ? [selectedDietaryRestriction] : []} 
      />
      <div className="flex flex-col mb-0">
        <GeneralButton type="button" buttonType="secondary" onClick={handleFilterClear}>
          Clear Filters
        </GeneralButton>
      </div>
    </div>
  );
}

export default ItemFilterComponent;
